module.exports = __webpack_public_path__ + "img/task-square.eff8d8c6.svg";